import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as i1 from '@spartacus/core';
import { Config, CxEvent, GlobalMessageType, LanguageSetEvent, CurrencySetEvent, LogoutEvent, LoginEvent, provideDefaultConfigFactory, provideDefaultConfig, AuthGuard, facadeFactory } from '@spartacus/core';
import * as i1$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import { CmsPageGuard, PageLayoutComponent, LAUNCH_CALLER } from '@spartacus/storefront';
import { Subscription, merge } from 'rxjs';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CustomerTicketingConfig = /*#__PURE__*/(() => {
  class CustomerTicketingConfig {
    static {
      this.ɵfac = function CustomerTicketingConfig_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CustomerTicketingConfig)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CustomerTicketingConfig,
        factory: function CustomerTicketingConfig_Factory(__ngFactoryType__) {
          let __ngConditionalFactory__ = null;
          if (__ngFactoryType__) {
            __ngConditionalFactory__ = new (__ngFactoryType__ || CustomerTicketingConfig)();
          } else {
            __ngConditionalFactory__ = i0.ɵɵinject(Config);
          }
          return __ngConditionalFactory__;
        },
        providedIn: 'root'
      });
    }
  }
  return CustomerTicketingConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const MAX_INPUT_CHARACTERS = 5000;
const MAX_INPUT_CHARACTERS_FOR_SUBJECT = 255;
const MAX_SIZE_FOR_ATTACHMENT = 10;
const MAX_ENTRIES_FOR_ATTACHMENT = 1;
const DATE_FORMAT = 'MMMM d, YYYY h:mm aa';
const LIST_VIEW_PAGE_SIZE = 5;

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultCustomerTicketingConfig = {
  customerTicketing: {
    attachmentRestrictions: {
      maxSize: MAX_SIZE_FOR_ATTACHMENT,
      allowedTypes: ['.pdf', '.txt', '.png', '.jpg', '.jpeg', '.gif', '.doc', '.docx', '.html', '.htm', '.zip']
    },
    inputCharactersLimit: MAX_INPUT_CHARACTERS,
    inputCharactersLimitForSubject: MAX_INPUT_CHARACTERS_FOR_SUBJECT,
    listViewPageSize: LIST_VIEW_PAGE_SIZE
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultCustomerTicketingRoutingConfig = {
  routing: {
    routes: {
      supportTickets: {
        paths: ['my-account/support-tickets']
      },
      supportTicketDetails: {
        paths: ['my-account/support-ticket/:ticketCode'],
        paramsMapping: {
          ticketCode: 'ticketCode'
        }
      }
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const CUSTOMER_TICKETING_FEATURE = 'customerTicketing';
const CUSTOMER_TICKETING_CORE_FEATURE = 'customerTicketingCore';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let GetTicketQueryResetEvent = /*#__PURE__*/(() => {
  class GetTicketQueryResetEvent extends CxEvent {
    static {
      this.type = 'GetTicketQueryResetEvent';
    }
  }
  return GetTicketQueryResetEvent;
})();
let GetTicketQueryReloadEvent = /*#__PURE__*/(() => {
  class GetTicketQueryReloadEvent extends CxEvent {
    static {
      this.type = 'GetTicketQueryReloadEvent';
    }
  }
  return GetTicketQueryReloadEvent;
})();
let GetTicketsQueryResetEvents = /*#__PURE__*/(() => {
  class GetTicketsQueryResetEvents extends CxEvent {
    static {
      this.type = 'GetTicketsQueryResetEvents';
    }
  }
  return GetTicketsQueryResetEvents;
})();
let GetTicketsQueryReloadEvents = /*#__PURE__*/(() => {
  class GetTicketsQueryReloadEvents extends CxEvent {
    static {
      this.type = 'GetTicketsQueryReloadEvents';
    }
  }
  return GetTicketsQueryReloadEvents;
})();
let NewMessageEvent = /*#__PURE__*/(() => {
  class NewMessageEvent extends CxEvent {
    static {
      this.type = 'NewMessageEvent';
    }
  }
  return NewMessageEvent;
})();
let TicketReopenedEvent = /*#__PURE__*/(() => {
  class TicketReopenedEvent extends CxEvent {
    static {
      this.type = 'TicketReopenedEvent';
    }
  }
  return TicketReopenedEvent;
})();
let TicketClosedEvent = /*#__PURE__*/(() => {
  class TicketClosedEvent extends CxEvent {
    static {
      this.type = 'TicketClosedEvent';
    }
  }
  return TicketClosedEvent;
})();
let GetTicketCategoryQueryResetEvent = /*#__PURE__*/(() => {
  class GetTicketCategoryQueryResetEvent extends CxEvent {
    static {
      this.type = 'GetTicketCategoryQueryResetEvent';
    }
  }
  return GetTicketCategoryQueryResetEvent;
})();
let GetTicketCategoryQueryReloadEvent = /*#__PURE__*/(() => {
  class GetTicketCategoryQueryReloadEvent extends CxEvent {
    static {
      this.type = 'GetTicketCategoryQueryReloadEvent';
    }
  }
  return GetTicketCategoryQueryReloadEvent;
})();
let GetTicketAssociatedObjectsQueryResetEvent = /*#__PURE__*/(() => {
  class GetTicketAssociatedObjectsQueryResetEvent extends CxEvent {
    static {
      this.type = 'GetTicketAssociatedObjectsQueryResetEvent';
    }
  }
  return GetTicketAssociatedObjectsQueryResetEvent;
})();
let GetTicketAssociatedObjectsQueryReloadEvent = /*#__PURE__*/(() => {
  class GetTicketAssociatedObjectsQueryReloadEvent extends CxEvent {
    static {
      this.type = 'GetTicketAssociatedObjectsQueryReloadEvent';
    }
  }
  return GetTicketAssociatedObjectsQueryReloadEvent;
})();
let TicketCreatedEvent = /*#__PURE__*/(() => {
  class TicketCreatedEvent extends CxEvent {
    static {
      this.type = 'TicketCreatedEvent';
    }
  }
  return TicketCreatedEvent;
})();
let CreateEvent = /*#__PURE__*/(() => {
  class CreateEvent extends CxEvent {
    static {
      this.type = 'CreateEvent';
    }
  }
  return CreateEvent;
})();
let UploadAttachmentSuccessEvent = /*#__PURE__*/(() => {
  class UploadAttachmentSuccessEvent extends CxEvent {
    static {
      this.type = 'UploadAttachmentSuccessEvent';
    }
  }
  return UploadAttachmentSuccessEvent;
})();
/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CustomerTicketingEventListener = /*#__PURE__*/(() => {
  class CustomerTicketingEventListener {
    constructor(eventService, globalMessageService) {
      this.eventService = eventService;
      this.globalMessageService = globalMessageService;
      this.subscriptions = new Subscription();
      this.onLanguageAndCurrencySetEvent();
      this.onLoginAndLogoutEvent();
      this.onTicketCreatedEvent();
      this.onNewMessage();
      this.onTicketClosed();
      this.onTicketReopened();
      this.onUploadAttachmentSucess();
    }
    onTicketCreatedEvent() {
      this.subscriptions.add(this.eventService.get(TicketCreatedEvent).subscribe(() => {
        this.globalMessageService.add({
          key: 'createCustomerTicket.ticketCreated'
        }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
        this.eventService.dispatch({}, GetTicketsQueryReloadEvents);
      }));
    }
    onLanguageAndCurrencySetEvent() {
      this.subscriptions.add(merge(this.eventService.get(LanguageSetEvent), this.eventService.get(CurrencySetEvent)).subscribe(() => {
        this.eventService.dispatch({}, GetTicketsQueryReloadEvents);
        this.eventService.dispatch({}, GetTicketQueryReloadEvent);
      }));
    }
    onLoginAndLogoutEvent() {
      this.subscriptions.add(merge(this.eventService.get(LogoutEvent), this.eventService.get(LoginEvent)).subscribe(() => {
        this.eventService.dispatch({}, GetTicketQueryResetEvent);
        this.eventService.dispatch({}, GetTicketsQueryResetEvents);
        this.eventService.dispatch({}, GetTicketCategoryQueryResetEvent);
        this.eventService.dispatch({}, GetTicketAssociatedObjectsQueryResetEvent);
      }));
    }
    onNewMessage() {
      this.subscriptions.add(this.eventService.get(NewMessageEvent).subscribe(() => {
        this.eventService.dispatch({}, GetTicketQueryReloadEvent);
      }));
    }
    onTicketClosed() {
      this.subscriptions.add(this.eventService.get(TicketClosedEvent).subscribe(() => {
        this.eventService.dispatch({}, GetTicketQueryResetEvent);
        this.globalMessageService.add({
          key: 'customerTicketingDetails.requestClosed'
        }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
      }));
    }
    onTicketReopened() {
      this.subscriptions.add(this.eventService.get(TicketReopenedEvent).subscribe(() => {
        this.eventService.dispatch({}, GetTicketQueryReloadEvent);
        this.globalMessageService.add({
          key: 'customerTicketingDetails.requestReopened'
        }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
      }));
    }
    onUploadAttachmentSucess() {
      this.subscriptions.add(this.eventService.get(UploadAttachmentSuccessEvent).subscribe(() => {
        this.eventService.dispatch({}, GetTicketQueryReloadEvent);
      }));
    }
    ngOnDestroy() {
      this.subscriptions.unsubscribe();
    }
    static {
      this.ɵfac = function CustomerTicketingEventListener_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CustomerTicketingEventListener)(i0.ɵɵinject(i1.EventService), i0.ɵɵinject(i1.GlobalMessageService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CustomerTicketingEventListener,
        factory: CustomerTicketingEventListener.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CustomerTicketingEventListener;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CustomerTicketingEventModule = /*#__PURE__*/(() => {
  class CustomerTicketingEventModule {
    constructor(_customerTicketingEventListener) {
      // Intentional empty constructor
    }
    static {
      this.ɵfac = function CustomerTicketingEventModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CustomerTicketingEventModule)(i0.ɵɵinject(CustomerTicketingEventListener));
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CustomerTicketingEventModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return CustomerTicketingEventModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function defaultCustomerTicketingComponentsConfig() {
  const config = {
    featureModules: {
      [CUSTOMER_TICKETING_FEATURE]: {
        cmsComponents: ['SupportTicketHistoryComponent', 'SupportTicketUpdateComponent', 'SupportTicketDetailsComponent', 'SupportTicketReopenComponent', 'SupportTicketCloseComponent', 'MyAccountViewRequestsComponent']
      },
      // by default core is bundled together with components
      [CUSTOMER_TICKETING_CORE_FEATURE]: CUSTOMER_TICKETING_FEATURE
    }
  };
  return config;
}
let CustomerTicketingRootModule = /*#__PURE__*/(() => {
  class CustomerTicketingRootModule {
    static {
      this.ɵfac = function CustomerTicketingRootModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CustomerTicketingRootModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CustomerTicketingRootModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfigFactory(defaultCustomerTicketingComponentsConfig), provideDefaultConfig(defaultCustomerTicketingRoutingConfig), provideDefaultConfig(defaultCustomerTicketingConfig)],
        imports: [CustomerTicketingEventModule, RouterModule.forChild([{
          // @ts-ignore
          path: null,
          canActivate: [AuthGuard, CmsPageGuard],
          component: PageLayoutComponent,
          data: {
            cxRoute: 'supportTicketDetails'
          }
        }, {
          // @ts-ignore
          path: null,
          canActivate: [AuthGuard, CmsPageGuard],
          component: PageLayoutComponent,
          data: {
            cxRoute: 'supportTickets'
          }
        }])]
      });
    }
  }
  return CustomerTicketingRootModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CustomerTicketingFacade = /*#__PURE__*/(() => {
  class CustomerTicketingFacade {
    static {
      this.ɵfac = function CustomerTicketingFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CustomerTicketingFacade)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CustomerTicketingFacade,
        factory: () => (() => facadeFactory({
          facade: CustomerTicketingFacade,
          feature: CUSTOMER_TICKETING_FEATURE,
          methods: ['getTicketState', 'getTicket', 'getTicketsState', 'getTickets', 'createTicketEvent', 'getTicketCategoriesState', 'getTicketCategories', 'getTicketAssociatedObjectsState', 'getTicketAssociatedObjects', 'createTicket', 'uploadAttachment', 'downloadAttachment']
        }))(),
        providedIn: 'root'
      });
    }
  }
  return CustomerTicketingFacade;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
LAUNCH_CALLER['CUSTOMER_TICKETING_REOPEN'] = 'CUSTOMER_TICKETING_REOPEN';
LAUNCH_CALLER['CUSTOMER_TICKETING_CLOSE'] = 'CUSTOMER_TICKETING_CLOSE';
LAUNCH_CALLER['CUSTOMER_TICKETING_CREATE'] = 'CUSTOMER_TICKETING_CREATE';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var TEXT_COLOR_CLASS = /*#__PURE__*/function (TEXT_COLOR_CLASS) {
  TEXT_COLOR_CLASS["GREY"] = "cx-text-grey";
  TEXT_COLOR_CLASS["GREEN"] = "cx-text-green";
  return TEXT_COLOR_CLASS;
}(TEXT_COLOR_CLASS || {});
var STATUS = /*#__PURE__*/function (STATUS) {
  STATUS["OPEN"] = "OPEN";
  STATUS["CLOSED"] = "CLOSED";
  STATUS["INPROCESS"] = "INPROCESS";
  return STATUS;
}(STATUS || {});
var STATUS_NAME = /*#__PURE__*/function (STATUS_NAME) {
  STATUS_NAME["OPEN"] = "Open";
  STATUS_NAME["CLOSED"] = "Closed";
  STATUS_NAME["INPROCESS"] = "INPROCESS";
  return STATUS_NAME;
}(STATUS_NAME || {});
/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/** AUGMENTABLE_TYPES_END */

/**
 * Generated bundle index. Do not edit.
 */

export { CUSTOMER_TICKETING_CORE_FEATURE, CUSTOMER_TICKETING_FEATURE, CreateEvent, CustomerTicketingConfig, CustomerTicketingEventListener, CustomerTicketingEventModule, CustomerTicketingFacade, CustomerTicketingRootModule, DATE_FORMAT, GetTicketAssociatedObjectsQueryReloadEvent, GetTicketAssociatedObjectsQueryResetEvent, GetTicketCategoryQueryReloadEvent, GetTicketCategoryQueryResetEvent, GetTicketQueryReloadEvent, GetTicketQueryResetEvent, GetTicketsQueryReloadEvents, GetTicketsQueryResetEvents, LIST_VIEW_PAGE_SIZE, MAX_ENTRIES_FOR_ATTACHMENT, MAX_INPUT_CHARACTERS, MAX_INPUT_CHARACTERS_FOR_SUBJECT, MAX_SIZE_FOR_ATTACHMENT, NewMessageEvent, STATUS, STATUS_NAME, TEXT_COLOR_CLASS, TicketClosedEvent, TicketCreatedEvent, TicketReopenedEvent, UploadAttachmentSuccessEvent, defaultCustomerTicketingComponentsConfig, defaultCustomerTicketingConfig };
